import { useContext } from 'react';
import { useRouter } from 'next/router';
import { styled } from '@nx-kit/styling';
import { BreakpointContext } from 'contexts/breakpoint/BreakpointContext';
import getDevice from 'helpers/getDevice';
import getSpacing from './helpers/getSpacing';

interface CmsElmtWrapperProps {
  id?: string;
  nextSlice?: string;
  sliceName: string;
  children?: React.ReactNode;
}

const Div = styled.div<{ spacing: number }>`
  margin-bottom: ${(props) => props.spacing}px;
`;

const CmsElmtWrapper: React.FC<CmsElmtWrapperProps> = ({ nextSlice, sliceName, id, children }) => {
  const { asPath } = useRouter();
  const breakpoint = useContext(BreakpointContext);
  const spacingBreakpoint = getDevice(breakpoint, 'smartphone') ? 'xs' : 'xl';

  // Museum-partners page only: tighten the gap between consecutive image_text
  // (logo) blocks. Everywhere else image_text keeps its normal spacing.
  const isPartnerLogoGap =
    asPath.includes('museumspartner') && sliceName === 'image_text' && nextSlice === 'image_text';
  const spacing = isPartnerLogoGap
    ? spacingBreakpoint === 'xs'
      ? 16
      : 50
    : getSpacing(spacingBreakpoint, sliceName, nextSlice);

  return (
    <Div as="section" id={id} spacing={spacing} data-slice-name={sliceName}>
      {children}
    </Div>
  );
};

export default CmsElmtWrapper;
